import { useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, ArrowLeft, ArrowRight } from "lucide-react";

export default function ReadingLesson({ lesson, onProgress }) {
  const sections = lesson.reading_sections || [];
  const [read, setRead] = useState(lesson.read_sections || []);
  const [index, setIndex] = useState(() => Math.max(0, sections.findIndex((_, i) => !(lesson.read_sections || []).includes(i))));
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const section = sections[index];
  const finish = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/lessons/${lesson.id}/read`, { section: index, quiz_version: lesson.quiz_version });
      setRead(data.read_sections); onProgress(data.pct);
      if (index < sections.length - 1) setIndex(index + 1);
    } catch (e) { setError(e.response?.data?.detail || "تعذر حفظ القراءة. أعد المحاولة."); }
    finally { setBusy(false); }
  };
  if (!section) return <p>محاور الدرس غير متاحة.</p>;
  return <div className="space-y-5" data-testid="reading-lesson">
    <div className="flex flex-wrap gap-2">{sections.map((s, i) => <button key={i} className={`v2-btn-ghost v2-btn-sm ${index === i ? "!text-beige-ink" : ""}`} aria-current={index === i ? "step" : undefined} onClick={() => setIndex(i)}>
      {read.includes(i) && <CheckCircle2 size={14} />}{s.title}
    </button>)}</div>
    <article className="space-y-4 py-3" aria-live="polite"><p className="text-xs text-ink-2">المحور {index + 1} من {sections.length}</p><h2 className="text-xl font-bold">{section.title}</h2>
      <p className="text-sm sm:text-base leading-loose whitespace-pre-line">{section.body}</p>
    </article>
    <div className="flex gap-3 items-center"><button className="v2-btn-ghost v2-btn-sm disabled:opacity-30" disabled={!index || busy} onClick={() => setIndex(index - 1)}><ArrowRight size={15} />السابق</button>
      <button className="v2-btn v2-btn-sm mr-auto disabled:opacity-40" disabled={busy} onClick={finish}>{busy ? "جارٍ الحفظ..." : index === sections.length - 1 ? "أكملت القراءة" : "قرأت المحور، التالي"}<ArrowLeft size={15} /></button></div>
    {read.length === sections.length && <p className="text-sm text-ok" role="status">أكملت المحاور. أجب عن السؤالين أدناه لإكمال الدرس.</p>}
    {error && <p role="alert" className="text-sm text-beige-ink">{error}</p>}
    <p className="text-xs text-ink-2">{lesson.content_origin}</p>
  </div>;
}
